import React, { useContext, useEffect, useRef, useState } from "react";
import "./dailyAttendance.css";
import DataTable from "react-data-table-component";
import { Fetchdata } from "../hooks/getData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthContext from "../context/auth-context";
import Spinner from "../loading/spinner";
import NepaliDate from "nepali-date-converter";
import StaffContext from "../adminPanel/organization/staffState/StaffContext";
import Toast from "../Toast";
import { GetTwelveHourFormatTime } from "../hooks/dateConvertor";
import UpperbarContext from "../context/upperbar-context";

export default function DailyAttendance({
  fromDate,
  toDate,
  DFlag,
  reload,
  appURL,
}) {
  const { customStyles } = useContext(UpperbarContext);
  const { User } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [attendanceList, setAttendanceList] = useState([]);
  const weekDay = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const columns = [
    {
      name: "S.N.",
      grow: 0,
      center: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Date",
      center: true,
      minWidth: "150px",
      selector: (row) => row.AttenDay,
    },

    {
      name: "Day",
      center: true,
      grow: 0,
      minWidth: "150px",
      selector: (row) => {
        if (DFlag === "N") {
          const nDate = new NepaliDate(row.AttenDay).getBS();
          //
          const day = nDate.day;
          return weekDay[day];
        } else {
          const day = new Date(row.AttenDay).getDay();

          return weekDay[day];
        }
      },
    },

    {
      name: "Check In",
      center: true,
      minWidth: "150px",
      selector: (row) => {
        if (row.CheckIn === null) {
          return "No Check In";
        } else {
          return row.CheckIn;
        }
      },
    },
    {
      name: "Check Out",
      center: true,
      minWidth: "150px",
      selector: (row) => {
        if (row.CheckOut === null) {
          return "No Check Out";
        } else {
          return row.CheckOut;
        }
      },
    },
    {
      name: "Day Type",
      center: true,
      selector: (row) => row.DayType,
    },
    {
      name: "Working Hour",
      center: true,
      selector: (row) => row.WorkingHour,
    },
 
    {
      name: "Remark",
      center: true,
      width: "250px",
      selector: (row) => {
        if (row.CheckIn === "No Check In" && row.CheckOut === "No Check Out") {
          if (row.LeaveID != "0") {
            return "On Leave";
          } else {
            return "Absent";
          }
        } else {
          if (row.IsVerified === "Verified") {
            const remark = row.InRemarks + " | " + row.OutRemarks;
            return remark;
          } else if (row.IsVerified === "Unverified") {
            return "In review";
          } else {
            return "Rejected";
          }
        }
      },
    },
  ];

  useEffect(() => {
    if (Object.keys(User).length && fromDate && toDate) {
      const dataForm = {
        Type: "GET",
        FetchURL: `${appURL}api/olite/attendance-report?ComID=${User.CompanyId}&UserID=${User?.UserID}&Flag=D&DFlag=${DFlag}&From=${fromDate}&To=${toDate}`,
      };

      Fetchdata(dataForm)
        .then(function (result) {
          if (result.StatusCode === 200) {
            const postResult = result.AttenRepMonth ? result.AttenRepMonth : "";
            setAttendanceList(postResult);
            setLoading(false);
          } else {
            setAttendanceList([]);
            setLoading(false);
          }
        })
        .catch((err) => {
          setAttendanceList([]);
          setLoading(false);
        });
    }
  }, [fromDate, toDate, reload]);

  return (
    <>
      {/* <Toast /> */}
      <div>
        {loading ? (
          <>
            {/* <div
              className=" text-center d-flex flex-column justify-content-center align-items-center"
              style={{ margin: "10% auto", width: "120px" }}
            >
              <p className="initial-msg">Please provide input!</p>
            </div> */}
            <Spinner />
          </>
        ) : (
          <DataTable
            columns={columns}
            data={attendanceList}
            customStyles={customStyles}
            pagination
            fixedHeader
            fixedHeaderScrollHeight="370px"
            highlightOnHover
            pointerOnHover
            responsive
            progressPending={loading}
            dense
            striped
          />
        )}
      </div>
    </>
  );
}
